exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".is_open i {\n  transform: rotate(-180deg);\n}\n.listFiles {\n  padding-left: 5px;\n  float: left;\n  padding-top: 1px;\n  padding-bottom: 5px;\n  padding-right: 20px;\n}\n.img-icon {\n  width: 35px;\n  height: 35px;\n  border: 1px solid #fff;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/pages/admin/evs/product/product_list.css
// module id = ../../../../../src/app/pages/admin/evs/product/product_list.css
// module chunks = 3